var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loggedIn
    ? _c(
        "div",
        {
          staticClass: "gift-choice-page",
          class: _vm.isBundle ? "bundle" : "",
          attrs: { id: "canvas" }
        },
        [
          _c(
            "div",
            {
              staticClass: "main-container no-scrollbar",
              attrs: { id: "mContainer" }
            },
            [
              _vm.collectionImage
                ? _c("img", {
                    staticClass: "custom-header desktop",
                    attrs: { src: _vm.collectionImage.src, width: "1920px" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.collectionImage
                ? _c("img", {
                    staticClass: "custom-header mobile",
                    attrs: { src: _vm.collectionImage.alt, width: "1920px" }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.collectionImage
                ? _c("p", { staticClass: "main-title" }, [
                    _vm._v("Time to Pick Your Gift!")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.collectionImage
                ? _c("p", { staticClass: "main-subtitle" }, [
                    _vm._v(
                      "You can pick one or many gifts to hit the value your sender has selected. Go ahead, have fun."
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tabs",
                  class: [
                    _vm.isSticking ? "sticky" : "",
                    _vm.showTicker ? "hasTicker" : ""
                  ],
                  attrs: { id: "tabs" }
                },
                _vm._l(_vm.tabs, function(tab, i) {
                  return _c(
                    "div",
                    {
                      staticClass: "tab",
                      class: [
                        _vm.selectedTab == tab.value ||
                        (!_vm.selectedTab && i == 0)
                          ? "selected"
                          : "",
                        _vm.isBundle &&
                        tab.value > 0 &&
                        _vm.tabs[tab.value - 1].currentQty > 0
                          ? "disabled"
                          : ""
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "happybox-button white",
                          on: {
                            click: function($event) {
                              return _vm.selectTab(tab.value)
                            }
                          }
                        },
                        [
                          _vm.isBundle
                            ? _c("span", [
                                _vm._v("Step " + _vm._s(i + 1) + ": ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Pick " +
                                _vm._s(tab.currentQty) +
                                " " +
                                _vm._s(tab.maxQty > 1 ? "gifts" : "gift")
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "arrow down" })
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "products-listing" }, [
                _vm.maxProductsToAdd == 0
                  ? _c("p", { staticClass: "capacity-overlay" }, [
                      _vm._v("100% full! Proceed to the next step "),
                      _c("br", { staticClass: "mobile" }),
                      _vm._v(" or remove items to keep shopping.")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bundleInstructions && _vm.maxProductsToAdd != 0
                  ? _c("p", {
                      staticClass: "bundle-instructions",
                      domProps: { innerHTML: _vm._s(_vm.bundleInstructions) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "products-inner-container",
                    class: _vm.maxProductsToAdd == 0 ? "disabled" : ""
                  },
                  _vm._l(_vm.filteredProducts, function(product) {
                    return _c(
                      "div",
                      {
                        key: product.id,
                        staticClass: "product-container",
                        class: _vm.cartProducts.find(function(x) {
                          return x.id == product.id
                        })
                          ? "selected"
                          : ""
                      },
                      [
                        _c("img", {
                          staticClass: "circle remove",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                            alt: "x"
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeProduct(product)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "product-image-container",
                            on: {
                              click: function($event) {
                                return _vm.selectProduct(product)
                              }
                            }
                          },
                          [
                            _vm.mainBadge(product) != null
                              ? _c("span", { staticClass: "main-badge" }, [
                                  _vm._v(_vm._s(_vm.mainBadge(product)))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "info mobile",
                              attrs: {
                                src:
                                  "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_9b78e5b1-b9be-49ca-826c-b3734c2991c5.svg?v=1683232689"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "loading" }, [
                              _c("img", {
                                staticClass: "lazyload main-image",
                                attrs: {
                                  width: "150",
                                  height: "150",
                                  src: product.images[0].src
                                }
                              })
                            ]),
                            _vm._v(" "),
                            product.images.length > 1
                              ? _c("img", {
                                  staticClass: "hover-image",
                                  attrs: { src: product.images[1].src }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "product-title" }, [
                          _vm._v(_vm._s(product.title))
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("SideCart", {
            attrs: {
              capacity: _vm.percentageFilledCapacity,
              selectedProducts: _vm.cartProducts,
              maxProductsToAdd: _vm.maxProductsToAdd,
              isLoading: _vm.isLoading,
              isBundle: _vm.isBundle,
              tabs: _vm.tabs
            },
            on: {
              removeproduct: function($event) {
                return _vm.removeProduct($event)
              },
              openmodal: function($event) {
                return _vm.openModal($event)
              }
            }
          }),
          _vm._v(" "),
          _vm.selectedProduct
            ? _c("ProductModal", {
                attrs: {
                  collectionValue: _vm.collectionValue,
                  availableCapacity: _vm.availableCapacity,
                  product: _vm.selectedProduct,
                  cartProducts: _vm.cartProducts,
                  isLoading: _vm.isLoading,
                  isBundle: _vm.isBundle,
                  tabs: _vm.tabs
                },
                on: {
                  closemodal: _vm.closeModal,
                  selectproduct: function($event) {
                    return _vm.addProduct($event)
                  },
                  cleanadd: function($event) {
                    return _vm.cleanAdd($event)
                  },
                  nextstep: function($event) {
                    return _vm.nextStep()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "spinner-container", class: _vm.reclaimed ? "top" : "" },
        [
          _vm.invalidToken
            ? _c("p", [_vm._v("Invalid Access")])
            : _vm.reclaimed
            ? _c("div", { staticClass: "reclaimed-container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v("You'll receive updates and tracking info via email!")
                ])
              ])
            : _c("div", { staticClass: "loading-container" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "spinner" })
              ])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Great Choice")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n    If you are having trouble loading this page, please turn off your VPN or company wifi. "
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v(
        " Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift."
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v("\n    If you are still having issues, please reach out to "),
      _c("a", { attrs: { href: "mailto:orders@happyboxstore.com" } }, [
        _vm._v("orders@happyboxstore.com")
      ]),
      _vm._v(" for immediate assistance.\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }